import produce from 'immer';
import { useEffect, useReducer, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { useDispatch, useSelector } from 'react-redux';

import AnalyticIcon from '../assets/svg/sell/analytic.svg';
import BadgeIcon from '../assets/svg/sell/badge.svg';
import Banner from '../assets/svg/sell/banner_sell.svg';
import DollarIcon from '../assets/svg/sell/dollar.svg';
import ExtensiveIcon from '../assets/svg/sell/extensive.svg';
import IntimateIcon from '../assets/svg/sell/intimate.svg';
import LaunchIcon from '../assets/svg/sell/launch.svg';
import PayIcon from '../assets/svg/sell/pay.svg';
import PeopleStar from '../assets/svg/sell/people_star.svg';
import RecommendIcon from '../assets/svg/sell/recommend.svg';
import ReportIcon from '../assets/svg/sell/report.svg';
import ReviewIcon from '../assets/svg/sell/review.svg';
import SslIcon from '../assets/svg/sell/ssl.svg';
import StartSelling from '../assets/svg/sell/start_selling.svg';
import TickIcon from '../assets/svg/sell/tick.svg';
import TrackRecordIcon from '../assets/svg/sell/track_record.svg';
import TranslateIcon from '../assets/svg/sell/translate.svg';
import TransparentIcon from '../assets/svg/sell/transparent.svg';
import UpdateNameserver from '../assets/svg/sell/update_nameserver.svg';
import UploadFileIcon from '../assets/svg/sell/upload_file.svg';
import UploadName from '../assets/svg/sell/upload_names.svg';

import Brooke from '../assets/users/user_brooke.png';
import Jeff from '../assets/users/user_jeff.png';
import Kris from '../assets/users/user_kris.png';
import Paul from '../assets/users/user_paul.png';
import Pete from '../assets/users/user_pete.png';
import Robert from '../assets/users/user_robert.png';

import BuyerData from '../assets/img/sell/buyer_data.png';
import FlexiPay from '../assets/img/sell/flexi_pay.png';
import Report from '../assets/img/sell/report.png';

import PhoneInput from 'react-phone-number-input';
import { postSellPremiumDomain } from 'store/actions/sell.action';
import * as types from 'store/actions/types';
import { RootState } from 'store/reducers';
import { history } from 'utils/handler';
import { ContributedDomains } from './components/CommonPages';

interface sellForm {
  name: string;
  email: string;
  phone: string;
  domain: string;
  price: string;
  terms: boolean;
  comment: string;
}
interface ReducerAction {
  type: string;
  name: string;
  payload?: string | boolean | Partial<sellForm>;
}

const domains = [
  'Arbitrage.com',
  'Coolest.com',
  'Wy.law',
  'Cerebral.com',
  'PartWorld.com',
  'Health.fit',
  'BookNook.com',
  'VCPVentures.com',
  'SparkLink.org',
  'EncompassTech.com',
  'Pesto.app',
  'DirectDrive.com',
  'Gtic.com',
  'Joyy.com',
  'GoodLeap.com',
  'BitOasis.com',
  'Gallea.com',
  'BitNinja.com',
  'Wine52.com',
  'Replika.com',
  'ThreatBook.com',
  'Artio.com',
  'Realm.com',
  'CapWay.com',
  'M1.com',
  'TellItYourWay.com',
  'Docus.com',
  'Showpiece.com',
  'Sg.law',
  'Low.beer',
  'Shod.com',
  'OnlyNews.com',
  'B.fit',
  'KaraokeRentals.com',
  'CapitalWaste.com',
  'Sindica.com',
  'ClaimSherpa.com',
  'Valery.ca',
  'PaintBallGuns.net',
  'Maze.co.uk',
  'Oz.zone',
  'SilverCut.com',
  '714.com',
  'WowDelivered.com',
  'TwoTen.com',
  'TrustIn.com',
  'Strollee.com',
  'Showpiece.com',
  'ShowIt.com',
  'Sexy.tv',
  'Salesman.com',
  'RichmondCapital.com',
  'Pyp.com',
  'Krista.ai',
  'Kidstoo.com',
  'Heretic.xyz',
  'Fancy.com',
  'Enode.com',
  'DoubleThink.com',
  'Desky.com',
  'CommonMedia.com',
  'Co2.com',
  'Max.law',
  'Miki.com',
  'Lollipop.com',
  'Archive.com',
  'Go.tv',
  'Mr.com',
  'Fm.com',
  'Data.ai',
  'GotMail.com',
  'Fis.com',
  'Ecobot.com',
  'LinkMore.com',
  'GoFreight.com',
  'Ali.vip',
  'Cyber.law',
  'Athletic.fit',
  'Botanic.grden',
  'Pro.vip',
  'Q.vip',
  'Sj.work',
  'V.vip',
  'Ai.com',
  'Ollie.com',
  'Storyboard.com',
  'AiFi.com',
  'Kevel.com',
  'Aphrodite.com',
  'Yakuza.io',
  'Agru.com',
  'GpTravel.com',
  'VictorG.com',
  'HeroesOnly.com',
  'Coopman.us',
  'Lyphe.com',
  'Vellucci.com',
  'Nudge.net',
  'Tornado.com',
  'BestWallet.com',
];

const initialState = {
  name: '',
  email: '',
  phone: '',
  domain: '',
  price: '',
  comment: '',
  terms: false,
};

const domainReducer = produce((state: sellForm, action: ReducerAction) => {
  const { type, name, payload } = action;
  switch (type) {
    case 'UPDATE':
      state = Object.assign(state, payload);
      return;
    case 'ON_TYPE':
      state[name] = payload;
      return;
    default:
      return;
  }
});

const errorReducer = produce((state: sellForm, action: ReducerAction) => {
  const { type, name, payload } = action;
  switch (type) {
    case 'ADD_ERROR':
      state[name] = payload;
      return;
    case 'DELETE_ERROR':
      state[name] = '';
      return;
    default:
      return;
  }
});

const Sell = () => {
  let dispatch = useDispatch();
  const [domainDetails, setDomainDetails] = useReducer(domainReducer, initialState);
  const [error, setError] = useReducer(errorReducer, initialState);
  const [soldList, setSoldList] = useState(false);
  const [apiLoad, setApiLoad] = useState(false);
  const { localCountryStr } = useSelector((state: RootState) => state.mainReducer);
  const { myProfile } = useSelector((state: RootState) => state.userReducer);
  const formNameRef = useRef<null | HTMLInputElement>(null);
  const fullServiceRef = useRef<null | HTMLInputElement>(null);
  const selfServiceRef = useRef<null | HTMLInputElement>(null);

  const validation = {
    name(value: string) {
      const empty = !value || !value.trim();
      if (empty) setError({ type: 'ADD_ERROR', name: 'name', payload: "Full name can't be empty." });
      else setError({ type: 'DELETE_ERROR', name: 'name' });
      if (empty) return true;
      else return false;
    },
    email(value: string) {
      const empty = !value || !value.trim();
      const isValid = value && !/^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value);
      if (empty) setError({ type: 'ADD_ERROR', name: 'email', payload: "Email address can't be empty." });
      else if (isValid) setError({ type: 'ADD_ERROR', name: 'email', payload: 'Email address is not valid.' });
      else setError({ type: 'DELETE_ERROR', name: 'email' });
      if (empty || isValid) return true;
      else return false;
    },
    phone(value: string | undefined) {
      const empty = !value || !value.trim();
      const isValid = value && !isValidPhoneNumber(value);
      if (empty) setError({ type: 'ADD_ERROR', name: 'phone', payload: "Phone number can't be empty." });
      else if (isValid) setError({ type: 'ADD_ERROR', name: 'phone', payload: 'Phone number is not valid.' });
      else setError({ type: 'DELETE_ERROR', name: 'phone' });
      if (empty || isValid) return true;
      else return false;
    },
    domain(value: string) {
      const empty = !value || !value.trim();
      const isValid = value && !/\w+\.\w\w+/gm.test(value);
      if (empty) setError({ type: 'ADD_ERROR', name: 'domain', payload: "Domain name can't be empty." });
      else if (isValid) setError({ type: 'ADD_ERROR', name: 'domain', payload: 'Domain name is not valid.' });
      else setError({ type: 'DELETE_ERROR', name: 'domain' });
      if (empty || isValid) return true;
      else return false;
    },
    price(value: string) {
      const empty = !value || !value.trim();
      const less = value && Number(value) < 1;
      if (empty) setError({ type: 'ADD_ERROR', name: 'price', payload: "Domain price can't be empty." });
      else if (less) setError({ type: 'ADD_ERROR', name: 'price', payload: "Domain price can't be negative." });
      else setError({ type: 'DELETE_ERROR', name: 'price' });
      if (empty || less) return true;
      else return false;
    },
    terms(value: boolean) {
      if (!value) setError({ type: 'ADD_ERROR', name: 'terms', payload: 'Please accept privacy policy & terms of service.' });
      else setError({ type: 'DELETE_ERROR', name: 'terms' });
      if (!value) return true;
      else return false;
    },
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const { domain, email, name, phone, price, terms, comment } = domainDetails;

    let error = false;
    const domainError = validation.domain(domain);
    if (domainError) error = true;
    const emailError = validation.email(email);
    if (emailError) error = true;
    const nameError = validation.name(name);
    if (nameError) error = true;
    const phoneError = validation.phone(phone);
    if (phoneError) error = true;
    const priceError = validation.price(price);
    if (priceError) error = true;
    const termsError = validation.terms(terms);
    if (termsError) error = true;

    if (error) return;

    const sell_ref = localStorage.getItem('sell_ref');
    const sell_referrer = localStorage.getItem('sell_referrer');
    let source = '';
    if (sell_ref && sell_referrer) source = `${sell_ref} --> ${sell_referrer}`;
    else if (sell_ref || sell_referrer) source = `${sell_ref ? sell_ref : ''}${sell_referrer ? sell_referrer : ''}`;
    setApiLoad(true);
    postSellPremiumDomain({ domain, email, name, phone, comment, price: +price, source })
      .then((data) => {
        if (data) {
          history.push('/sell-domain?show=thankyou');
          if (source) {
            localStorage.removeItem('sell_ref');
            localStorage.removeItem('sell_referrer');
          }
        }
      })
      .finally(() => setApiLoad(false));
  };

  useEffect(() => {
    if (myProfile?.email) {
      const { name, email, phone } = myProfile;
      setDomainDetails({ type: 'UPDATE', name: '', payload: { name, email, phone } });
    }
  }, [myProfile]);

  useEffect(() => {
    const search = history.location.search;
    const query = new URLSearchParams(search);
    const sell_ref = query.get('ref');
    if (sell_ref) localStorage.setItem('sell_ref', sell_ref);
    const sell_referrer = document.referrer;
    if (sell_referrer) localStorage.setItem('sell_referrer', sell_referrer);
  }, []);

  return (
    <div className="">
      <Helmet>
        <title>Saw.com Domain Selling Service: Get Top $ For Your Domain</title>
      </Helmet>
      <div className="sell_bg_2">
        <div className="container d-lg-flex py-5">
          <div className="">
            <h1 className="sell_h1">No-Stress Domain Selling Service</h1>
            <div className="sell_p_v2 sell_hero_content mt-2 text-left">
              <div>
                <strong> Looking to sell your domains for top dollar? Sell with Saw.com for the best prices!</strong>
              </div>
              <div>Whether you prefer our expert brokerage service with over $550 million in sales or our advanced self-service platform, we help you maximize your sales value</div>
            </div>
            <div className="d-flex ml-2 mt-2">
              <img src={TickIcon} alt="" />
              <div className="ml-2 sell_p_v1">Obtain detailed buyer insights to aid pricing decisions</div>
            </div>
            <div className="d-flex ml-2">
              <img src={TickIcon} alt="" />
              <div className="ml-2 sell_p_v1">Analyze domain traffic by location</div>
            </div>
            <div className="d-flex ml-2 mb-2">
              <img src={TickIcon} alt="" />
              <div className="ml-2 sell_p_v1">Tap into our experienced sales team</div>
            </div>
            {/* <div className="d-flex ml-2 mb-2">
              <img src={TickIcon} alt="" />
              <div className="ml-2 sell_p_v1">Benefit from multi-language support and diverse checkout options</div>
            </div> */}
            <div className="d-flex flex-column flex-sm-row align-items-center justify-content-around">
              <button
                className="sell_btn bg_pri"
                onClick={() => {
                  if (fullServiceRef && fullServiceRef.current) fullServiceRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }}
              >
                Full Service Brokerage
              </button>
              <button
                className="sell_btn bg_sec"
                onClick={() => {
                  if (selfServiceRef && selfServiceRef.current) selfServiceRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }}
              >
                Self Service Brokerage
              </button>
            </div>
            <div className="help-content mt-2">
              <ContributedDomains smallSection={true} />
            </div>
            {/* <h5 className="sell_hero_h5">Our team has contributed to $500m+ in domain transactions:</h5>
            <div className="d-flex justify-content-between flex-wrap">
              <img className="sell_hero_logo" src={trgr_logo} alt="BGR" />
              <img className="sell_hero_logo" src={kevel_logo} alt="Kevel" />
              <img className="sell_hero_logo" src={westcap_logo} alt="WestCAP" />
              <img className="sell_hero_logo" src={gc_logo} alt="Infinity" />
              <img className="sell_hero_logo" src={colab_logo} alt="Go Lab" />
              <img className="sell_hero_logo" src={yac_logo} alt="Yac" />
              <img className="sell_hero_logo" src={alloy_logo} alt="Alloy" />
            </div> */}
          </div>
          <div className="p-2 sell_hero_img mt-5 mt-lg-0">
            <img src={Banner} alt="" />
          </div>
        </div>
      </div>

      <div className="container text-center mt-5" id="full_service_brokerage" ref={fullServiceRef}>
        <div className="mt-5">
          <h2 className="sell_h2 text-center">Trust a Domain Broker Service With Consistent Domain Name Sales</h2>
          <p className="sell_p text-center mt-3">Created by domain industry veterans with experience in building domain marketplaces like Uniregistry, DomainNameSales, and NameLot, the Saw.com sales platform is unique. Our team has orchestrated thousands of successful sales totaling over half a billion dollars.</p>
          <p className="sell_p text-center mt-3">Achieving such success requires sales skills and a management platform to analyze, organize, and understand domain metrics, traffic data, and inquiry origins.</p>
          <p className="sell_p text-center mb-3">Our services provide just that. Do you want to use our platform independently or prefer our brokerage services as well?</p>
        </div>
        <div className="d-flex flex-wrap my-4">
          <div className="text-center col-12 col-sm-6 col-lg-3 right_border_odd">
            <img src={AnalyticIcon} alt="" height={48} width={48} />
            <p>
              <strong> Access buyer data to make better decisions</strong>
            </p>
          </div>
          <div className="text-center col-12 col-sm-6 col-lg-3 right_border_even">
            <img src={PeopleStar} alt="" height={48} width={48} />
            <p>
              <strong>Crafted by the creators of Uniregistry, and Namelot</strong>
            </p>
          </div>
          <div className="text-center col-12 col-sm-6 col-lg-3 right_border_odd">
            <img src={TranslateIcon} alt="" />
            <p>
              <strong>Support in English, Spanish and Mandarin</strong>
            </p>
          </div>
          <div className="text-center col-12 col-sm-6 col-lg-3">
            <img src={DollarIcon} alt="" />
            <p>
              <strong>$550,000 in collective domain sales</strong>
            </p>
          </div>
        </div>
        <div className="d-flex justify-content-center my-5">
          <a href="https://market.saw.com/auth/sign-in">
            <button className="sell_btn bg_pri">Start Selling</button>
          </a>
        </div>
        <div className="sell_bg_1 sell_b_1 text-center mx-3 mx-sm-5 mt-3 mb-5 p-2 px-lg-5 py-lg-5">
          <div className="sell_star">
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
          </div>
          <div className="sell_h4 text-center sell_main_blue">Future Media Architects</div>
          <div className="sell_p text-center">“We have worked with Saw.com since their inception and would not work with anyone else. They help us in all facets of business - from sales and transfers to renewals, SSL issues and any other matters that may arise. You will not find a better, more trustworthy business that has maximized our profits.”</div>
        </div>
      </div>

      <div className="sell_bg_2">
        <div className="container text-center py-5">
          <div className="">
            <h3 className="sell_h2 text-center">Talented Domain Name Brokers, On Your Side</h3>
            <div className="sell_p text-center">Our domain name brokers are some of the brightest minds in the business, boasting years of domain name knowledge, access to the WHOIS database and a proven track record of experience (we’re talking more than half a BILLION dollars in sales!)</div>
            <div className="sell_p text-center mt-3">After managing thousands of valuable domain name transactions, we’ve perfected the process to sell domain names with maximized returns. Our team is expertly placed to receive leads, educate potential buyers and build a rapport that secures a successful sale.</div>
          </div>
          <div className="sell_agent mt-5 text-left">
            <div className="d-flex flex-column flex-sm-row p-3 sell_agent_bg">
              <img src={Brooke} alt="Broker agent" className="text-center" width={100} height={100} />
              <div className="ml-2 mt-2 mt-sm-0">
                <div className="sell_h3 sell_main_blue">Brooke Hernandez</div>
                <div className="sell_h5">More than a decade of success in top-level domain name sales and acquisitions.</div>
                <div className="sell_h5 sell_wt_600 mt-2">Notable Sales:</div>
                <div className="sell_h5 sell_c sell_wp_pl sell_agent_domain">arbitrage.com, bunny.com, kevel.com, plane.com</div>
                <div className="sell_h5 sell_wt_600 mt-2">Speaks:</div>
                <div className="sell_h5">English and Spanish</div>
              </div>
            </div>
            <div className="d-flex flex-column flex-sm-row p-3 sell_agent_bg">
              <img src={Robert} alt="Broker agent" width={100} height={100} />
              <div className="ml-2 mt-2 mt-sm-0">
                <div className="sell_h3 sell_main_blue">Robert Watson</div>
                <div className="sell_h5">A tried-and-tested domain broker and reseller with more than 1,000 successful sales.</div>
                <div className="sell_h5 sell_wt_600 mt-2">Notable Sales:</div>
                <div className="sell_h5 sell_c sell_wp_pl sell_agent_domain">note.com, yolo.com, anna.com, busy.com, selling.com</div>
                <div className="sell_h5 sell_wt_600 mt-2">Speaks:</div>
                <div className="sell_h5">English and Spanish</div>
              </div>
            </div>
            <div className="d-flex flex-column flex-sm-row p-3 sell_agent_bg">
              <img src={Kris} alt="Broker agent" width={100} height={100} />
              <div className="ml-2 mt-2 mt-sm-0">
                <div className="sell_h3 sell_main_blue">Kris Hou</div>
                <div className="sell_h5">15 years of global domain name sales experience with some impressive wins.</div>
                <div className="sell_h5 sell_wt_600 mt-2">Notable Sales:</div>
                <div className="sell_h5 sell_c sell_wp_pl sell_agent_domain">cool.com, perfect.com, fancy.com, virtual.com</div>
                <div className="sell_h5 sell_wt_600 mt-2">Speaks:</div>
                <div className="sell_h5">English and Mandarin</div>
              </div>
            </div>
            <div className="d-flex flex-column flex-sm-row p-3 sell_agent_bg">
              <img src={Paul} alt="Broker agent" width={100} height={100} />
              <div className="ml-2 mt-2 mt-sm-0">
                <div className="sell_h3 sell_main_blue">Paul Thomson</div>
                <div className="sell_h5">A domain name sales pro since the 80s (sorry Paul!) with deep branding knowledge.</div>
                <div className="sell_h5 sell_wt_600 mt-2">Notable Sales:</div>
                <div className="sell_h5 sell_c sell_wp_pl sell_agent_domain">aliens.com, nonfiction.com, edstart.com, legging.com</div>
                <div className="sell_h5 sell_wt_600 mt-2">Speaks:</div>
                <div className="sell_h5">English</div>
              </div>
            </div>
            <div className="d-flex flex-column flex-sm-row p-3 sell_agent_bg">
              <img src={Pete} alt="Broker agent" width={100} height={100} />
              <div className="ml-2 mt-2 mt-sm-0">
                <div className="sell_h3 sell_main_blue">Peter McHugh</div>
                <div className="sell_h5">Over 10 years’ experience selling top level domain names, with some eye-catching sales and acquisitions along the way.</div>
                <div className="sell_h5 sell_wt_600 mt-2">Notable Sales:</div>
                <div className="sell_h5 sell_c sell_wp_pl sell_agent_domain">scenes.com, nad.com, stoke.com, wayward.com</div>
                <div className="sell_h5 sell_wt_600 mt-2">Speaks:</div>
                <div className="sell_h5">English</div>
              </div>
            </div>
          </div>
          <div className="mt-5 sell_b_2 sell_bg_3">
            <div className="position-relative d-flex justify-content-center">
              <span className="sell_h5 sell_c p-3 position-relative sell_zIndex_10 sell_cursor_pointer sell_domain_mw" onClick={() => setSoldList((prev) => !prev)}>
                View a selection of Saw.com’s notable domain name sales
              </span>
              <i className={`fa-solid sell_caret_icon ${soldList ? 'fa-caret-up' : 'fa-caret-down'}`} onClick={() => setSoldList((prev) => !prev)}></i>
            </div>
            {soldList && (
              <div className="row row-cols-2 row-cols-sm-3 row-cols-lg-4 mx-1 mx-sm-2 overflow-auto">
                {domains.map((item, i) => (
                  <p key={i}>{item}</p>
                ))}
              </div>
            )}
          </div>
          <div className="d-flex align-items-center flex-column mt-5">
            <img src={Jeff} alt="broker agent" width={150} height={150} />
            <div className="sell_h2 mt-4">All Brokers Are Overseen By Our CEO, Jeffrey Gabriel...</div>
            <div className="sell_p mt-3">Jeff’s wide-ranging experience in the domain niche includes a VP of Sales role at Uniregistry where he contributed to $500m in blockbuster domain name sales. He held the Guinness World Record for highest domain name sale of a .com (sex for $13m) and a .org (poker for $1m).</div>
            <div className="sell_p mt-3">Through the deep expertise of Jeff and his team - whether it’s for a premium domain or the domain marketplace in general - Saw.com is here to simplify the sales process. With our website builder, we deliver a professional shop window for your domain names that finds a domain buyer and maximizes your payout.</div>
          </div>
        </div>
      </div>

      <div className="container text-center">
        <div className="">
          <h2 className="sell_h2 mt-5">Sell Your Domain Name The Saw.com Way</h2>
          <h4 className="sell_h3_v1">Our Proven Domain Sale Process Gets You The Best Price</h4>
        </div>
        <div className="d-flex justify-content-around flex-wrap mt-5">
          <div className="d-flex flex-column align-items-center p-3 p-lg-5 m-1 sell_process_card">
            <div className="sell_process_count">1.</div>
            <img src={UploadName} alt="" width={75} height={75} />
            <div className="sell_h4 mt-3">Upload Names</div>
            <div className="sell_h5_v1 mt-3">Copy and paste - or upload a file - with your domain names for our brokers to review</div>
          </div>
          <div className="d-flex flex-column align-items-center p-3 p-lg-5 m-1 sell_process_card">
            <div className="sell_process_count">2.</div>
            <img src={UpdateNameserver} alt="" width={75} height={75} />
            <div className="sell_h4 mt-3">Update Nameservers</div>
            <div className="sell_h5_v1 mt-3">Change the nameservers for your domains so we can add them to the Saw.com system</div>
          </div>
          <div className="d-flex flex-column align-items-center p-3 p-lg-5 m-1 sell_process_card">
            <div className="sell_process_count">3.</div>
            <img src={StartSelling} alt="" width={75} height={75} />
            <div className="sell_h4 mt-3">Start Selling</div>
            <div className="sell_h5_v1 mt-3">Work with our brokers (and website builder!) to help you sell - with secure payment processing</div>
          </div>
        </div>
        <div className="d-flex justify-content-center my-5">
          <a href="https://market.saw.com/auth/sign-in">
            <button className="sell_btn bg_pri">Start Selling</button>
          </a>
        </div>

        <h2 className="sell_h2 mt-5" id="self_service_brokerage" ref={selfServiceRef}>
          Smarter Self-Brokerage With Saw.com
        </h2>
        <div className="sell_p mt-3">Our complete self-service solution allows you to skillfully broker your domains without the usual stress. With individual landing pages for each name, sales analytics in a user-friendly dashboard and the option to speak directly with potential buyers - we deliver all the tools you need to sell your domains effectively.</div>

        <div className="d-flex flex-wrap my-5 sell_feature">
          <div className="text-center col-12 col-sm-6 col-lg-3">
            <img src={ReportIcon} alt="" />
            <p>
              <strong>Access inquirer details, origins and traffic data.</strong>
            </p>
          </div>
          <div className="text-center col-12 col-sm-6 col-lg-3">
            <img src={PayIcon} alt="" />
            <p>
              <strong>Flexible payment options to cater to a global economy.</strong>
            </p>
          </div>
          <div className="text-center col-12 col-sm-6 col-lg-3">
            <img src={SslIcon} alt="" />
            <p>
              <strong>Each custom sales lander receives its own SSL.</strong>
            </p>
          </div>
          <div className="text-center col-12 col-sm-6 col-lg-3">
            <img src={BadgeIcon} alt="" />
            <p>
              <strong>On demand access to our award winning domain brokerage.</strong>
            </p>
          </div>
        </div>

        <div className="d-flex justify-content-center my-5">
          <a href="https://market.saw.com/auth/sign-in">
            <button className="sell_btn bg_pri">Start Selling</button>
          </a>
        </div>

        <div className="my-5 sell_dash_ui">
          <div>
            <div className="sell_dash_ui_content">
              <div className="sell_h3_v2 sell_wt_600">Access to Full Buyer’s Data</div>
              <div>We provide our clients with detailed insights about potential buyers. This transparency empowers sellers to make more informed pricing decisions to shape their strategies to maximize returns.</div>
            </div>
            <div>
              <img src={BuyerData} alt="" />
            </div>
          </div>
          <div>
            <div>
              <img src={Report} alt="" />
            </div>
            <div className="sell_dash_ui_content">
              <div className="sell_h3_v2 sell_wt_600">Data-Driven Insights</div>
              <div>We provide our clients with more data about their domains than any other marketplace. This includes appraised values, the number of extensions the keyword is registered in, and specific geographical traffic data.</div>
            </div>
          </div>
          <div>
            <div className="sell_dash_ui_content">
              <div className="sell_h3_v2 sell_wt_600">Flexible Payment Options</div>
              <div>Offer various payment methods and plans to accommodate different buyer preferences and facilitate transactions.</div>
            </div>
            <div>
              <img src={FlexiPay} alt="" />
            </div>
          </div>
        </div>

        <div className="">
          <h2 className="sell_h2_v1 sell_wt_600">Get Complete Control of Your Domain Sales Process</h2>
          <h3 className="sell_h3_v2 sell_wt_600 sell_c4">Here’s How It Works…</h3>
          <div className="d-flex justify-content-around flex-wrap mt-5">
            <div className="d-flex flex-column align-items-center p-3 m-1 sell_domain_card">
              <div className="sell_domain_card_count">1.</div>
              <img src={UploadFileIcon} alt="" width={53} height={53} />
              <div className="sell_h5_v3 mt-3">Upload your domains to your Saw.com account.</div>
            </div>
            <div className="d-flex flex-column align-items-center p-3 m-1 sell_domain_card">
              <div className="sell_domain_card_count">2.</div>
              <img src={RecommendIcon} alt="" width={53} height={53} />
              <div className="sell_h5_v3 mt-3">Choose to self-broker or utilize our award-winning domain brokerage service.</div>
            </div>
            <div className="d-flex flex-column align-items-center p-3 m-1 sell_domain_card">
              <div className="sell_domain_card_count">3.</div>
              <img src={LaunchIcon} alt="" width={53} height={53} />
              <div className="sell_h5_v3 mt-3">Benefit from our lightning-fast sales landers, each secured with its own SSL certificate.</div>
            </div>
            <div className="d-flex flex-column align-items-center p-3 m-1 sell_domain_card">
              <div className="sell_domain_card_count">4.</div>
              <img src={ReviewIcon} alt="" width={53} height={53} />
              <div className="sell_h5_v3 mt-3">Sell, and get paid! It is that simple.</div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-center my-5">
          <a href="https://market.saw.com/auth/sign-in">
            <button className="sell_btn bg_pri">Start Selling</button>
          </a>
        </div>
      </div>

      {false && (
        <div className="sell_bg_4 sell_hide">
          <div className="container py-5 d-flex flex-column flex-lg-row" id="premium_domain">
            <div className="col-lg-6 sell_c1 mt-5">
              <div className="sell_h1 mt-lg-5">Are You An Ultra-Premium Domain Owner?</div>
              <div className="sell_h5_v2 mt-3">If you’ve got a high-profile domain name, a Saw.com domain broker is perfectly placed to sell it. They’ll work round the clock to source, contract and negotiate with your ideal buyer - just fill out the contact information form below to request a personal discussion and explore our domain broker service.</div>
              <ul className="mt-3 ultra_premium_cond">
                <li>Domain name must have a .com extension</li>
                <li>Domain name must be worth more than $100,000</li>
                <li>Domain owner must agree to exclusive listing</li>
              </ul>
            </div>
            <div className="col-lg-6 sell_bg_3 p-2 p-sm-4 p-xl-5 sell_premium_container mb-5 mt-lg-5">
              <div>
                <input
                  className={`sell_premium_input sell_width_fix saw-input form-control ${error.name ? 'is-invalid' : ''}`}
                  type="text"
                  placeholder="Full Name*"
                  value={domainDetails.name}
                  ref={formNameRef}
                  onChange={(e) => {
                    const value = e.target.value;
                    setDomainDetails({ type: 'ON_TYPE', name: 'name', payload: value });
                    validation.name(value);
                  }}
                />
                {error.name && <div className="sell_form_error">{error.name}</div>}
              </div>
              <div>
                <input
                  className={`sell_premium_input sell_width_fix saw-input form-control ${error.email ? 'is-invalid' : ''}`}
                  type="email"
                  placeholder="Email Address*"
                  value={domainDetails.email}
                  onChange={(e) => {
                    const value = e.target.value;
                    setDomainDetails({ type: 'ON_TYPE', name: 'email', payload: value });
                    validation.email(value);
                  }}
                />
                {error.email && <div className="sell_form_error">{error.email}</div>}
              </div>
              <div>
                <PhoneInput
                  international
                  defaultCountry={localCountryStr}
                  placeholder="Enter phone number"
                  disabled={false}
                  value={domainDetails.phone}
                  onChange={(data) => {
                    setDomainDetails({ type: 'ON_TYPE', name: 'phone', payload: data });
                    validation.phone(data);
                  }}
                  className={`form-control sell_phone_input ${error.phone ? 'is-invalid' : ''}`}
                />
                {error.phone && <div className="sell_form_error">{error.phone}</div>}
              </div>

              <div className="sell_domain_price_container">
                <div>
                  <input
                    className={`sell_premium_input saw-input form-control ${error.domain ? 'is-invalid' : ''}`}
                    type="text"
                    placeholder="Domain Name*"
                    value={domainDetails.domain}
                    onChange={(e) => {
                      const value = e.target.value;
                      setDomainDetails({ type: 'ON_TYPE', name: 'domain', payload: value });
                      validation.domain(value);
                    }}
                  />
                  {error.domain && <div className="sell_form_error">{error.domain}</div>}
                </div>
                <div>
                  <input
                    className={`sell_premium_input saw-input form-control ${error.price ? 'is-invalid' : ''}`}
                    type="number"
                    placeholder="price*"
                    value={domainDetails.price}
                    onChange={(e) => {
                      const value = e.target.value;
                      setDomainDetails({ type: 'ON_TYPE', name: 'price', payload: value });
                      validation.price(value);
                    }}
                  />
                  {error.price && <div className="sell_form_error">{error.price}</div>}
                </div>
              </div>
              <textarea className="sell_premium_input sell_width_fix saw-input" name="" id="" rows={3} value={domainDetails.comment} onChange={(e) => setDomainDetails({ type: 'ON_TYPE', name: 'comment', payload: e.target.value })} placeholder="Any questions or comments for our team?"></textarea>
              <div>
                <div className="d-flex">
                  <input
                    type="checkbox"
                    className="flex-shrink-0"
                    id="ultra_premium_domain"
                    checked={domainDetails.terms}
                    onChange={() => {
                      const value = !domainDetails.terms;
                      setDomainDetails({ type: 'ON_TYPE', name: 'terms', payload: value });
                      validation.terms(value);
                    }}
                  />
                  <label htmlFor="ultra_premium_domain" className="sell_cursor_pointer">
                    I have read and accept the{' '}
                    <span
                      className="sell_terms"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        dispatch({ type: types.SELL_PRIVACY_POLICY, payload: true });
                      }}
                    >
                      Privacy Policy
                    </span>{' '}
                    &{' '}
                    <span
                      className="sell_terms"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        dispatch({ type: types.SELL_TERMS_AND_SERVICE, payload: true });
                      }}
                    >
                      Terms of Service
                    </span>
                  </label>
                </div>
                {error.terms && <div className="sell_form_error d-flex justify-content-center">{error.terms}</div>}
              </div>

              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-grad"
                  onClick={(e) => {
                    handleFormSubmit(e);
                  }}
                  disabled={apiLoad}
                >
                  {apiLoad ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="text-center sell_bg_2">
        <div className="container py-5">
          <div className="sell_h2">Why Sell With Us?</div>
          <div className="d-flex flex-column flex-lg-row mb-2 mt-5">
            <div className="d-flex flex-column align-items-center col-lg-6">
              <div className="flex-shrink-0 position-relative sell_with_us">
                <img src={ExtensiveIcon} alt="" width={60} height={60} />
              </div>
              <div className="px-4 sell_with_container">
                <div className="sell_h50"></div>
                <div className="sell_h4 mt-3">Extensive Experience</div>
                <div className="sell_h5_v1 mt-3 mb-4">Saw.com is full of experts who have worked with household brands and contributed to $500m+ in domain name transitions and blockbuster sales.</div>
              </div>
            </div>
            <div className="d-flex flex-column mt-4 mt-lg-0 align-items-center col-lg-6">
              <div className="flex-shrink-0 position-relative sell_with_us">
                <img src={IntimateIcon} alt="" width={60} height={60} />
              </div>
              <div className="px-4 sell_with_container">
                <div className="sell_h50"></div>
                <div className="sell_h4 mt-3">Intimate Service</div>
                <div className="sell_h5_v1 mt-3 mb-4">Saw.com only collaborates with companies who we feel can gain the most impact out of our services. We’re not a high-volume shop.</div>
              </div>
            </div>
          </div>

          <div className="d-flex mb-2 mt-4 flex-column flex-lg-row">
            <div className="d-flex flex-column align-items-center col-lg-6">
              <div className="flex-shrink-0 position-relative sell_with_us">
                <img src={TransparentIcon} alt="" width={60} height={60} />
              </div>
              <div className="px-4 sell_with_container">
                <div className="sell_h50"></div>
                <div className="sell_h4 mt-3">Always Transparent</div>
                <div className="sell_h5_v1 mt-3 mb-4">Saw.com consistently ensures transparency, integrity and a seamless process. We’ll always be upfront and honest about your domains.</div>
              </div>
            </div>
            <div className="d-flex flex-column mt-4 mt-lg-0 align-items-center col-lg-6">
              <div className="flex-shrink-0 position-relative sell_with_us">
                <img src={TrackRecordIcon} alt="" width={60} height={60} />
              </div>
              <div className="px-4 sell_with_container">
                <div className="sell_h50"></div>
                <div className="sell_h4 mt-3">Proven Track Record</div>
                <div className="sell_h5_v1 mt-3 mb-4">Saw.com is the industry leader in selling and buying domains and has experience like no other when it comes to every aspect of brokerage.</div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center my-5">
            <a href="https://market.saw.com/auth/sign-in">
              <button className="sell_btn bg_pri">Start Selling</button>
            </a>
          </div>
        </div>
      </div>

      <div className="container my-5">
        <div className="text-center sell_review p-4 p-lg-5">
          <div>
            <div className="sell_star">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </div>
            <div className="sell_h4 sell_c2 mt-3">Marc Lore | Serial Entrepreneur</div>
            <div className="sell_p mt-3">"When starting a company, the Saw.com team are some of the first people I call. A memorable name for a search engine, and the domain and social handles behind it, creates a huge amount of brand equity right out the gate — no matter how big or how small your company is. From diapers.com to jet.com (and many more to come!) the Saw.com team has helped my companies be seen."</div>
          </div>
        </div>
      </div>

      <div className="text-center sell_bg_4">
        <div className="sell_stat_illustration">
          <div className="container py-5">
            <div>
              <div className="sell_h2 sell_c1 mt-5">Ready To Get The Most From Your Domain Sale?</div>
              <div className="sell_h3_v1 sell_c1 mt-3 sell_stat_desc">Secure a serious, qualified buyer for your names with Saw.com, one of the world’s leading brokerage firms.</div>
            </div>
            <div className="d-flex justify-content-center my-5">
              <a href="https://market.saw.com/auth/sign-in">
                <button className="sell_btn bg_pri">Start Selling</button>
              </a>
            </div>
            <div className="d-flex flex-wrap my-5">
              <div className="text-center col-12 col-sm-6 col-lg-3 right_border_stat_odd">
                <div className="sell_h2 sell_c3">20</div>
                <div className="sell_stat_highlight">Years of Sales Knowledge</div>
              </div>
              <div className="text-center col-12 col-sm-6 col-lg-3 right_border_stat_even">
                <div className="sell_h2 sell_c3">1,000+</div>
                <div className="sell_stat_highlight">Domain Transactions</div>
              </div>
              <div className="text-center col-12 col-sm-6 col-lg-3 right_border_stat_odd">
                <div className="sell_h2 sell_c3">15%</div>
                <div className="sell_stat_highlight">Commission Payments</div>
              </div>
              <div className="text-center col-12 col-sm-6 col-lg-3">
                <div className="sell_h2 sell_c3">100%</div>
                <div className="sell_stat_highlight">Transparency and Commitment</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sell;
